import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomImageMagnifier } from "@tsesco/Components/CustomImageMagnifier";
import React, { useEffect, useRef } from "react";
import ReactImageMagnify, { LargeImageType, ReactImageMagnifyProps } from "react-image-magnify";
import { css } from "styled-components";

interface CustomReactImageMagnifyProps extends ReactImageMagnifyProps {
    largeImage: LargeImageType & { width: number; height: number };
}
export interface CheckoutShippingCarrierServiceStyles {
    mainWrapper: InjectableCss
}


export const imageMagnifier: CheckoutShippingCarrierServiceStyles = {
    mainWrapper: {
        css: css`
                width: 100%;
                display: flex;
                justify-content: center;
            img{
                max-height: 450px;
            }
           
        `,
    }
};

const styles = imageMagnifier;

export default function ImageMagnifierZoomNew({ imagePath }: { imagePath: string }) {
    const imgContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleImageHover = () => {
            const dataLayer = (window as any).dataLayer || [];
            if (dataLayer) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "zoomImage",
                });
            }
            return dataLayer;
        };

        const imgContainerElement = imgContainerRef.current;

        if (imgContainerElement) {
            imgContainerElement.addEventListener("mouseenter", handleImageHover);

            return () => {
                imgContainerElement.removeEventListener("mouseenter", handleImageHover);
            };
        }
    }, []);

    return (
        <StyledWrapper ref={imgContainerRef} {...styles.mainWrapper}>
            {/* <ReactImageMagnify
                style={{ cursor: "zoom-in"}}
                enlargedImageContainerDimensions={{
                    width: 450,
                    height: "100%",
                }}
                enlargedImageStyle={{
                    objectFit: "contain",
                    height: "100%",
                    scale:"1.9",
                    top:"0px",
                    marginTop:"170px",
                    paddingBottom:"40px",
                    paddingTop:"10px"
                }}
                shouldUsePositiveSpaceLens={true}
                lensStyle={{ background: "transparent" }}
                {...{
                    smallImage: {
                        alt: "PDP image",
                        isFluidWidth: true,
                        src: imagePath
                    },
                    largeImage: {
                        src: imagePath,
                        width: 800,
                        height: 600
                    },
                }}
                className="pdp_main_image"
            /> */}
            <CustomImageMagnifier
                imageUrl={imagePath}
                zoomFactor={2}
            />
        </StyledWrapper>
    );
}
